export default "__VITE_ASSET__72446816__"